// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Google Cloud DMS-Style Wizard */

.wizard-modal-overlay {
    background: rgba(10, 15, 30, 0.75) !important;
    backdrop-filter: blur(8px) !important;
}

html[data-theme='light'] .wizard-modal-overlay,
[data-theme='light'] .wizard-modal-overlay {
    background: rgba(232, 236, 248, 0.65) !important;
}

.wizard-modal {
    position: relative;
    background: var(--bg-primary, #0d1127) !important;
    backdrop-filter: none !important;
    border: 1px solid var(--glass-border, rgba(255, 255, 255, 0.05)) !important;
    background-clip: padding-box !important;
    border-radius: 24px;
    width: 95vw;
    max-width: 1240px;
    height: 92vh;
    max-height: 92vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3),
        0 8px 18px rgba(0, 0, 0, 0.2) !important;
    overflow: hidden;
}

html[data-theme='light'] .wizard-modal,
[data-theme='light'] .wizard-modal {
    background: linear-gradient(135deg, #eaedfa 0%, #dbe0f5 100%) !important;
    backdrop-filter: none !important;
    border: 1px solid var(--glass-border, rgba(0, 0, 0, 0.05)) !important;
    background-clip: padding-box !important;
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.04),
        0 4px 10px rgba(0, 0, 0, 0.02) !important;
}

.wizard-header {
    padding: 1.5rem 3rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: transparent !important;
}

html[data-theme='light'] .wizard-header,
[data-theme='light'] .wizard-header {
    background: transparent !important;
    border-bottom: 1px solid #E3E6EF !important;
}

.wizard-body {
    display: flex;
    flex: 1 1;
    overflow: hidden;
}

/* Left Sidebar */
.wizard-sidebar {
    width: 320px;
    flex-shrink: 0;
    background: transparent !important;
    border-right: 1px solid rgba(255, 255, 255, 0.05) !important;
    padding: 2.5rem 1.5rem;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
}

html[data-theme='light'] .wizard-sidebar,
[data-theme='light'] .wizard-sidebar {
    background: transparent !important;
    border-right: 1px solid var(--glass-border, rgba(0, 0, 0, 0.05)) !important;
}

.wizard-sidebar-actions {
    margin-top: auto;
    padding: 1rem 0;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    border-top: 1px solid var(--border-color);
}

.wizard-sidebar-actions button {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0.75rem 1rem;
    border-radius: 10px;
    font-size: 0.9rem;
    cursor: pointer;
    transition: all 0.2s;
    text-align: left;
    margin-bottom: 0.5rem;
    border: 1px solid transparent;
}

/* Replaced btn-save to be glossy navy blue down below */

.wizard-sidebar-actions .btn-discard {
    background: rgba(239, 68, 68, 0.05) !important;
    color: #ef4444 !important;
    font-weight: 500;
    border: 1px solid rgba(239, 68, 68, 0.1) !important;
}

.wizard-sidebar-actions .btn-discard:hover {
    background: rgba(239, 68, 68, 0.1) !important;
}

.wizard-step-item {
    display: flex;
    gap: 0.75rem;
    padding: 0.875rem;
    margin-bottom: 0.5rem;
    border-radius: 8px;
    transition: all 0.2s;
    cursor: default;
}

.wizard-step-item.pending {
    opacity: 0.5;
}

.wizard-step-item.active {
    background: var(--bg-button-secondary, #EEF1F8) !important;
    border-left: 4px solid var(--primary, #6366f1);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
    transform: translateX(5px);
}

.wizard-step-item.completed {
    opacity: 0.8;
}

.wizard-step-item .step-number {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75rem;
    font-weight: 700;
    flex-shrink: 0;
    background: var(--bg-button-secondary, #ffffff) !important;
    color: var(--text-muted);
    border: 2px solid var(--border-color) !important;
}

.wizard-step-item.active .step-number {
    background: #7c3aed !important;
    color: white !important;
    border-color: #7c3aed !important;
}

.wizard-step-item.completed .step-number {
    background: #10b981 !important;
    color: white !important;
    border-color: #10b981 !important;
}

.wizard-step-item .step-content {
    flex: 1 1;
    min-width: 0;
}

.wizard-step-item .step-title {
    font-size: 0.9375rem;
    font-weight: 500;
    color: var(--text-primary);
    margin-bottom: 0.25rem;
}

.wizard-step-item .step-subtitle {
    font-size: 0.8125rem;
    color: var(--text-muted);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.wizard-sidebar-actions {
    margin-top: auto;
    padding-top: 1.5rem;
    border-top: 1px solid var(--border-color);
}

/* Main Content Area */
.wizard-content {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;
    /* Hide the thick horizontal bar */
    min-width: 0;
    position: relative;
    background: transparent;
}

/* Refined Modern Scrollbar */
.wizard-content::-webkit-scrollbar,
.wizard-sidebar::-webkit-scrollbar,
.step-body::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

.wizard-content::-webkit-scrollbar-track,
.wizard-sidebar::-webkit-scrollbar-track,
.step-body::-webkit-scrollbar-track {
    background: transparent;
}

.wizard-content::-webkit-scrollbar-thumb,
.wizard-sidebar::-webkit-scrollbar-thumb,
.step-body::-webkit-scrollbar-thumb {
    background: rgba(102, 126, 234, 0.15);
    border-radius: 20px;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
}

.wizard-content::-webkit-scrollbar-thumb:hover,
.wizard-sidebar::-webkit-scrollbar-thumb:hover,
.step-body::-webkit-scrollbar-thumb:hover {
    background: rgba(102, 126, 234, 0.4);
}

.wizard-step-content {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    padding: 2.5rem 3rem;
    width: calc(100% - 3rem);
    /* Ensure consistent margins on both sides */
    box-sizing: border-box;
    background: var(--bg-card, rgba(20, 26, 48, 0.4)) !important;
    margin: 1.5rem;
    border-radius: 24px;
    box-shadow: none;
    border: 1px solid rgba(255, 255, 255, 0.05) !important;
}

html[data-theme='light'] .wizard-step-content,
[data-theme='light'] .wizard-step-content {
    background: var(--bg-card, rgba(255, 255, 255, 0.75)) !important;
    border: 1px solid var(--glass-border, rgba(0, 0, 0, 0.05)) !important;
    backdrop-filter: blur(12px) !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02) !important;
}

.step-header {
    margin-bottom: 2rem;
    flex-shrink: 0;
}

.step-header h3 {
    font-size: 1.5rem;
    font-weight: 600;
    color: var(--text-primary);
    margin-bottom: 0.5rem;
    margin-top: 0;
}

.step-header p {
    font-size: 0.9375rem;
    color: var(--text-muted);
    margin: 0;
}

.step-body {
    flex: 1 1;
    overflow-y: auto;
}

.step-footer {
    padding-top: 1.5rem;
    border-top: 1px solid rgba(102, 126, 234, 0.1);
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: auto;
    background: transparent;
    gap: 1.25rem;
    /* Added space between buttons */
}

.step-footer .btn-primary,
.wizard-sidebar-actions .btn-primary,
.wizard-sidebar-actions .btn-save {
    min-width: 140px;
    height: 46px;
    padding: 0 1.75rem;
    background: linear-gradient(180deg, #1e3a8a 0%, #172554 100%) !important;
    color: white !important;
    border: 1px solid #0f172a !important;
    border-radius: 12px;
    font-weight: 700;
    font-size: 0.95rem;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: inset 0 2px 4px rgba(255, 255, 255, 0.2), 0 4px 10px rgba(15, 23, 42, 0.4) !important;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.step-footer .btn-primary:hover:not(:disabled),
.wizard-sidebar-actions .btn-primary:hover:not(:disabled),
.wizard-sidebar-actions .btn-save:hover:not(:disabled) {
    transform: translateY(-2px);
    background: linear-gradient(180deg, #2563eb 0%, #1e3a8a 100%) !important;
    box-shadow: inset 0 2px 4px rgba(255, 255, 255, 0.3), 0 6px 15px rgba(15, 23, 42, 0.5) !important;
}

.step-footer .btn-primary:active:not(:disabled),
.wizard-sidebar-actions .btn-primary:active:not(:disabled),
.wizard-sidebar-actions .btn-save:active:not(:disabled) {
    background: #0f172a !important;
    box-shadow: inset 0 3px 6px rgba(0, 0, 0, 0.5) !important;
    transform: translateY(0);
}

.step-footer .btn-secondary {
    min-width: 140px;
    height: 46px;
    padding: 0 1.5rem;
    border-radius: 12px;
    font-weight: 600;
    font-size: 0.95rem;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

html[data-theme='light'] .step-footer .btn-secondary {
    background: #ffffff;
    border: 1px solid #2563EB;
    color: #2563EB;
}

html[data-theme='light'] .step-footer .btn-secondary:hover:not(:disabled) {
    background: #EFF6FF;
    border-color: #1D4ED8;
    color: #1D4ED8;
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(37, 99, 235, 0.2);
}

[data-theme='dark'] .step-footer .btn-secondary {
    background: #0F172A;
    border: 1px solid #3B82F6;
    color: #60A5FA;
}

[data-theme='dark'] .step-footer .btn-secondary:hover:not(:disabled) {
    border-color: #60A5FA;
    box-shadow: 0 0 12px rgba(59, 130, 246, 0.4);
    transform: translateY(-2px);
}

/* Button Styles */
.btn-text {
    background: none;
    border: none;
    color: var(--text-secondary);
    padding: 0.625rem 1rem;
    cursor: pointer;
    font-size: 0.9375rem;
    transition: all 0.2s;
}

.btn-text:hover {
    color: var(--text-primary);
    background: rgba(255, 255, 255, 0.05);
    border-radius: 6px;
}

.btn-text:disabled,
.btn-primary:disabled,
.btn-secondary:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    filter: grayscale(0.5);
    box-shadow: none !important;
    transform: none !important;
}

.form-control:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.wizard-modal .form-control {
    background: #F6F7FB !important;
    border: 1px solid #E3E6EF !important;
    color: var(--text-primary) !important;
    backdrop-filter: none;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.02);
}

.wizard-modal .form-control:focus {
    background: #ffffff !important;
    border-color: #6366f1 !important;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1) !important;
}

/* Dark Mode Overrides */
[data-theme='dark'] .wizard-modal {
    background: linear-gradient(135deg, #10142A 0%, #1C2340 100%) !important;
    border: 1px solid var(--glass-border, rgba(255, 255, 255, 0.05)) !important;
    backdrop-filter: none !important;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4),
        0 8px 18px rgba(0, 0, 0, 0.2) !important;
}

[data-theme='dark'] .wizard-header {
    background: transparent !important;
    border-bottom: 1px solid #1e2542 !important;
}

[data-theme='dark'] .wizard-header h2 {
    background: linear-gradient(135deg, #f8fafc 0%, #a5b4fc 100%);
    -webkit-background-clip: text;
    background-clip: text;
}

[data-theme='dark'] .wizard-sidebar {
    background: transparent !important;
    border-right: 1px solid var(--glass-border, rgba(255, 255, 255, 0.05)) !important;
}

[data-theme='dark'] .wizard-step-item .step-title {
    color: #f8fafc;
}

[data-theme='dark'] .wizard-step-item .step-subtitle {
    color: #cbd5e1;
}

[data-theme='dark'] .wizard-step-item.active {
    background: rgba(99, 102, 241, 0.16);
    border-left-color: #8b5cf6;
    box-shadow: 0 4px 15px rgba(139, 92, 246, 0.15), var(--glass-inner-glow);
}

[data-theme='dark'] .wizard-step-item .step-number {
    background: rgba(15, 22, 42, 0.6);
    border-color: rgba(255, 255, 255, 0.1);
    color: #cbd5e1;
}

[data-theme='dark'] .wizard-step-content {
    background: #1A1F36 !important;
    border: 1px solid var(--glass-border, rgba(255, 255, 255, 0.08)) !important;
    backdrop-filter: none !important;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2) !important;
}

[data-theme='dark'] .wizard-modal .form-control {
    background: #121625 !important;
    border-color: rgba(255, 255, 255, 0.1) !important;
    color: #f8fafc !important;
}

[data-theme='dark'] .step-header h3 {
    color: #ffffff;
}

[data-theme='dark'] .step-header p {
    color: #94a3b8;
}

[data-theme='dark'] .step-footer {
    border-top: 1px solid rgba(255, 255, 255, 0.08);
}

[data-theme='dark'] .step-footer .btn-secondary {
    background: rgba(255, 255, 255, 0.03);
    border-color: rgba(255, 255, 255, 0.1);
    color: #cbd5e1;
}

[data-theme='dark'] .step-footer .btn-secondary:hover {
    background: rgba(255, 255, 255, 0.08);
    border-color: #a855f7;
    color: #ffffff;
}

[data-theme='dark'] .wizard-sidebar-actions .btn-discard {
    background: rgba(239, 68, 68, 0.1) !important;
    border-color: rgba(239, 68, 68, 0.2) !important;
}

[data-theme='dark'] .wizard-modal .form-control,
[data-theme='dark'] .form-control {
    background: #182040 !important;
    border-color: #252e52 !important;
    color: #ffffff !important;
    backdrop-filter: none;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
}

[data-theme='dark'] .wizard-modal .form-control:focus {
    background: #1b2548 !important;
    border-color: #8b5cf6 !important;
    box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.15) !important;
}

[data-theme='dark'] label {
    color: #e2e8f0 !important;
}

[data-theme='dark'] .wizard-step-item.completed .step-number {
    background: #10b981 !important;
    border-color: #10b981 !important;
    color: white !important;
}

[data-theme='dark'] .wizard-step-item.completed {
    opacity: 1;
}

/* Theme-aware Connectivity Card */
.connectivity-card {
    background: #ffffff;
    border: 1px solid rgba(102, 126, 234, 0.15);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.06);
}

[data-theme='dark'] .connectivity-card {
    background: rgba(30, 41, 59, 0.5) !important;
    border: 1px solid rgba(255, 255, 255, 0.08) !important;
    box-shadow: none !important;
    backdrop-filter: blur(10px);
}

/* Runner IP Box */
.runner-ip-box {
    background: linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%);
    border: 2px solid #ddd6fe;
    box-shadow: 0 8px 20px rgba(124, 58, 237, 0.08);
}

.runner-ip-box code {
    color: #1f2937;
}

[data-theme='dark'] .runner-ip-box {
    background: rgba(99, 102, 241, 0.1) !important;
    border: 1px solid rgba(99, 102, 241, 0.2) !important;
    box-shadow: none !important;
}

[data-theme='dark'] .runner-ip-box code {
    color: #ffffff !important;
}

/* Info/Tip Box */
.info-box {
    background: #eff6ff;
    border: 1px solid #bfdbfe;
    color: #1e40af;
}

[data-theme='dark'] .info-box {
    background: rgba(59, 130, 246, 0.1) !important;
    border: 1px solid rgba(59, 130, 246, 0.2) !important;
    color: #93c5fd !important;
}

[data-theme='dark'] .connectivity-text {
    color: #94a3b8 !important;
}

[data-theme='dark'] .wizard-content {
    background: transparent !important;
}

[data-theme='dark'] .step-body {
    background: transparent;
}

/* Responsive */
@media (max-width: 968px) {
    .wizard-modal {
        width: 98vw;
        max-height: 95vh;
    }

    .wizard-sidebar {
        width: 240px;
    }

    .wizard-step-content {
        padding: 1.5rem;
    }
}

@media (max-width: 768px) {
    .wizard-body {
        flex-direction: column;
    }

    .wizard-sidebar {
        width: 100%;
        max-height: 200px;
        border-right: none;
        border-bottom: 1px solid var(--border-color);
        flex-direction: row;
        overflow-x: auto;
        padding: 1rem;
    }

    .wizard-step-item {
        flex-direction: column;
        align-items: center;
        text-align: center;
        min-width: 120px;
    }

    .wizard-sidebar-actions {
        display: none;
    }
}

/* Animations */
@keyframes scaleUp {
    from {
        transform: scale(0.95);
        opacity: 0;
    }

    to {
        transform: scale(1);
        opacity: 1;
    }
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.spin {
    animation: spin 1s linear infinite;
}

/* Cutover Modal Styles */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.modal-content {
    background: var(--bg-primary);
    border-radius: 12px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    max-width: 90vw;
    max-height: 90vh;
    overflow: hidden;
    animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
    from {
        transform: translateY(20px);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

.cutover-modal {
    max-width: 520px !important;
}

.cutover-modal .modal-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1.5rem 1.75rem;
    border-bottom: 1px solid var(--border-color);
    background: var(--bg-secondary);
}

.cutover-modal .modal-icon.warning {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(245, 158, 11, 0.15);
    color: #f59e0b;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.cutover-modal .modal-header h3 {
    flex: 1 1;
    margin: 0;
    font-size: 1.125rem;
    font-weight: 600;
    color: var(--text-primary);
}

.cutover-modal .modal-close {
    background: none;
    border: none;
    color: var(--text-muted);
    cursor: pointer;
    padding: 0.5rem;
    border-radius: 6px;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.cutover-modal .modal-close:hover {
    background: rgba(0, 0, 0, 0.05);
    color: var(--text-primary);
}

[data-theme='dark'] .cutover-modal .modal-close:hover {
    background: rgba(255, 255, 255, 0.05);
}

.cutover-modal .modal-body {
    padding: 1.75rem;
}

.cutover-modal .warning-text {
    font-size: 0.9375rem;
    color: var(--text-primary);
    margin: 0 0 1.25rem 0;
    font-weight: 500;
}

.cutover-modal .cutover-steps {
    margin: 0 0 1.5rem 0;
    padding-left: 1.25rem;
    color: var(--text-secondary);
    list-style: decimal;
}

.cutover-modal .cutover-steps li {
    margin: 0.625rem 0;
    font-size: 0.875rem;
    line-height: 1.5;
    padding-left: 0.5rem;
}

.cutover-modal .danger-text {
    margin: 0;
    padding: 0.875rem 1rem;
    background: rgba(239, 68, 68, 0.08);
    border-left: 3px solid #ef4444;
    border-radius: 6px;
    color: #ef4444;
    font-weight: 500;
    font-size: 0.875rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.cutover-modal .modal-footer {
    padding: 1.25rem 1.75rem;
    border-top: 1px solid var(--border-color);
    background: var(--bg-secondary);
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
}

.cutover-modal .modal-footer .btn-secondary {
    background: var(--bg-primary);
    color: var(--text-primary);
    border: 1px solid var(--border-color);
    padding: 0.625rem 1.25rem;
    border-radius: 6px;
    font-weight: 500;
    font-size: 0.875rem;
    cursor: pointer;
    transition: all 0.2s;
}

.cutover-modal .modal-footer .btn-secondary:hover {
    background: var(--bg-input);
    border-color: var(--text-muted);
}

.cutover-modal .btn-danger {
    background: #ef4444;
    color: white;
    border: none;
    padding: 0.625rem 1.5rem;
    border-radius: 6px;
    font-weight: 500;
    font-size: 0.875rem;
    cursor: pointer;
    transition: all 0.2s;
}

.cutover-modal .btn-danger:hover {
    background: #dc2626;
    box-shadow: 0 2px 8px rgba(239, 68, 68, 0.25);
}

.cutover-modal .btn-danger:active {
    transform: translateY(1px);
}

.stop-modal {
    max-width: 520px !important;
}

.stop-modal .modal-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1.5rem 1.75rem;
    border-bottom: 1px solid var(--border-color);
    background: var(--bg-secondary);
}

.stop-modal .modal-icon.danger {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(239, 68, 68, 0.15);
    color: #ef4444;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.stop-modal .modal-header h3 {
    flex: 1 1;
    margin: 0;
    font-size: 1.125rem;
    font-weight: 600;
    color: var(--text-primary);
}

.stop-modal .modal-close {
    background: none;
    border: none;
    color: var(--text-muted);
    cursor: pointer;
    padding: 0.5rem;
    border-radius: 6px;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.stop-modal .modal-close:hover {
    background: rgba(0, 0, 0, 0.05);
    color: var(--text-primary);
}

[data-theme='dark'] .stop-modal .modal-close:hover {
    background: rgba(255, 255, 255, 0.05);
}

.stop-modal .modal-body {
    padding: 1.75rem;
}

.stop-modal .warning-text {
    font-size: 0.9375rem;
    color: var(--text-primary);
    margin: 0 0 1.25rem 0;
    font-weight: 500;
}

.stop-modal .danger-text {
    margin: 0;
    padding: 0.875rem 1rem;
    background: rgba(239, 68, 68, 0.08);
    border-left: 3px solid #ef4444;
    border-radius: 6px;
    color: #ef4444;
    font-weight: 500;
    font-size: 0.875rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.stop-modal .modal-footer {
    padding: 1.25rem 1.75rem;
    border-top: 1px solid var(--border-color);
    background: var(--bg-secondary);
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
}

.stop-modal .modal-footer .btn-secondary {
    background: var(--bg-primary);
    color: var(--text-primary);
    border: 1px solid var(--border-color);
    padding: 0.625rem 1.25rem;
    border-radius: 6px;
    font-weight: 500;
    font-size: 0.875rem;
    cursor: pointer;
    transition: all 0.2s;
}

.stop-modal .modal-footer .btn-secondary:hover {
    background: var(--bg-input);
    border-color: var(--text-muted);
}

.stop-modal .btn-danger {
    background: #ef4444;
    color: white;
    border: none;
    padding: 0.625rem 1.5rem;
    border-radius: 6px;
    font-weight: 500;
    font-size: 0.875rem;
    cursor: pointer;
    transition: all 0.2s;
}

.stop-modal .btn-danger:hover {
    background: #dc2626;
    box-shadow: 0 2px 8px rgba(239, 68, 68, 0.25);
}

.stop-modal .btn-danger:active {
    transform: translateY(1px);
}

/* ==========================================================================
   PREMIUM TOOLBAR SECTION (Search, Filter, Sort, View Switcher)
   ========================================================================== */

.connections-toolbar-premium {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 0.75rem;
    /* 12px gaps between controls */
    margin-bottom: 2.5rem;
    padding: 0.5rem 0.5rem;
    width: 100%;
}

@media (max-width: 768px) {
    .connections-toolbar-premium {
        flex-direction: column;
        align-items: stretch;
        gap: 1rem;
    }

    .view-switcher-premium {
        width: 100%;
    }

    .btn-switcher-tab {
        flex: 1 1;
    }
}

/* --- Search Bar Glass Container --- */
.search-bar-glass-container {
    position: relative;
    flex: 1 1;
    display: flex;
    align-items: center;
    max-width: none;
    background: var(--bg-input, rgba(10, 12, 24, 0.45));
    backdrop-filter: blur(20px);
    border: 1px solid var(--border-glass, rgba(255, 255, 255, 0.08));
    border-radius: 12px;
    padding: 0 0.85rem;
    height: 42px;
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);
    transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}

html[data-theme='light'] .search-bar-glass-container {
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.08);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.02), 0 4px 15px rgba(0, 0, 0, 0.02);
}

.search-icon-dim {
    color: var(--text-muted);
    margin-right: 0.75rem;
    pointer-events: none;
    transition: color 0.28s;
}

input[type="text"].search-input-glass {
    flex: 1 1;
    border: none !important;
    background: transparent !important;
    color: var(--text-primary) !important;
    font-size: 0.9rem !important;
    font-weight: 500 !important;
    outline: none !important;
    padding: 0 !important;
    height: 100% !important;
    box-shadow: none !important;
    border-radius: 0 !important;
}

.search-input-glass::placeholder {
    color: var(--text-muted);
    opacity: 0.7;
}

.clear-search-btn {
    border: none;
    background: transparent;
    color: var(--text-muted);
    font-size: 1.2rem;
    cursor: pointer;
    padding: 0 4px;
    transition: color 0.2s;
    line-height: 1;
    display: flex;
    align-items: center;
}

.clear-search-btn:hover {
    color: var(--text-primary);
}

/* Focus State: Soft Cyan Glow */
.search-bar-glass-container:focus-within {
    border-color: rgba(6, 182, 212, 0.5) !important;
    box-shadow: 0 0 0 1px rgba(6, 182, 212, 0.2), 0 0 15px rgba(6, 182, 212, 0.15), inset 0 1px 1px rgba(255, 255, 255, 0.05);
}

html[data-theme='light'] .search-bar-glass-container:focus-within {
    border-color: rgba(6, 182, 212, 0.6) !important;
    box-shadow: 0 0 0 1px rgba(6, 182, 212, 0.2), 0 0 12px rgba(6, 182, 212, 0.12);
}

/* --- Dropdown controls --- */
.toolbar-actions-group {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

@media (max-width: 768px) {
    .toolbar-actions-group {
        justify-content: flex-start;
        width: 100%;
    }

    .toolbar-dropdown-container {
        flex: 1 1;
    }

    .btn-toolbar-dropdown {
        width: 100%;
        justify-content: space-between;
    }
}

.toolbar-dropdown-container {
    position: relative;
    z-index: 200;
    /* Ensure dropdown displays above table container content */
}

.btn-toolbar-dropdown {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    height: 42px;
    padding: 0 1.1rem;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.03);
    backdrop-filter: blur(16px);
    border: 1px solid rgba(255, 255, 255, 0.06);
    color: var(--text-secondary);
    font-size: 0.82rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
}

html[data-theme='light'] .btn-toolbar-dropdown {
    background: rgba(0, 0, 0, 0.01);
    border: 1px solid rgba(0, 0, 0, 0.06);
    color: #4b5563;
}

.btn-toolbar-dropdown:hover {
    background: rgba(255, 255, 255, 0.06);
    border-color: rgba(255, 255, 255, 0.12);
    color: var(--text-primary);
    transform: translateY(-1px);
}

html[data-theme='light'] .btn-toolbar-dropdown:hover {
    background: rgba(0, 0, 0, 0.03);
    border-color: rgba(0, 0, 0, 0.12);
    color: #111827;
}

.btn-toolbar-dropdown.active-filter {
    border-color: rgba(168, 85, 247, 0.4);
    background: rgba(168, 85, 247, 0.05);
    color: #a855f7;
}

html[data-theme='light'] .btn-toolbar-dropdown.active-filter {
    border-color: rgba(168, 85, 247, 0.5);
    background: rgba(168, 85, 247, 0.04);
    color: #7e22ce;
}

.chevron-rotate {
    transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}

.chevron-rotate.open {
    transform: rotate(180deg);
}

/* Floating Glass Dropdown Panel */
.dropdown-panel-glass {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    width: 220px;
    background: rgba(15, 23, 42, 0.85);
    backdrop-filter: blur(24px) saturate(180%);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 14px;
    padding: 0.4rem;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.05);
    z-index: 1000;
    
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transform: translateY(-8px) scale(0.97);
    transition: opacity 0.2s, visibility 0.2s, transform 0.2s;
}

.dropdown-panel-glass.open {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
    animation: slideDownFade 0.2s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

html[data-theme='light'] .dropdown-panel-glass {
    background: rgba(255, 255, 255, 0.95);
    border: 1px solid rgba(0, 0, 0, 0.08);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
}

@keyframes slideDownFade {
    from {
        opacity: 0;
        transform: translateY(-8px) scale(0.97);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

.dropdown-panel-header {
    font-size: 0.65rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: var(--text-muted);
    padding: 0.4rem 0.75rem;
    margin-bottom: 0.25rem;
}

.dropdown-panel-options {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.dropdown-option-btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0.55rem 0.75rem;
    border-radius: 8px;
    border: none;
    background: transparent;
    color: var(--text-secondary);
    font-size: 0.82rem;
    font-weight: 550;
    text-align: left;
    cursor: pointer;
    transition: all 0.2s;
}

html[data-theme='light'] .dropdown-option-btn {
    color: #4b5563;
}

.dropdown-option-btn:hover {
    background: rgba(255, 255, 255, 0.06);
    color: var(--text-primary);
}

html[data-theme='light'] .dropdown-option-btn:hover {
    background: rgba(0, 0, 0, 0.03);
    color: #111827;
}

.dropdown-option-btn.selected {
    background: rgba(99, 102, 241, 0.08);
    color: #818cf8;
}

html[data-theme='light'] .dropdown-option-btn.selected {
    background: rgba(99, 102, 241, 0.05);
    color: #4f46e5;
}

.check-icon-purple {
    color: #818cf8;
}

html[data-theme='light'] .check-icon-purple {
    color: #4f46e5;
}

/* --- View Switcher Segmented Control --- */
.view-switcher-premium {
    display: flex;
    align-items: center;
    height: 42px;
    background: rgba(255, 255, 255, 0.03);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 99px;
    /* Rounded pill container */
    padding: 3px;
    gap: 2px;
    box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.01), 0 4px 12px rgba(0, 0, 0, 0.05);
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

html[data-theme='light'] .view-switcher-premium {
    background: rgba(0, 0, 0, 0.015);
    border-color: rgba(0, 0, 0, 0.06);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.01), 0 2px 8px rgba(0, 0, 0, 0.02);
}

/* Subtle hover lift & shadow glow */
.view-switcher-premium:hover {
    transform: translateY(-1px);
    border-color: rgba(168, 85, 247, 0.2);
    box-shadow:
        0 6px 20px rgba(0, 0, 0, 0.15),
        0 0 10px rgba(168, 85, 247, 0.05),
        inset 0 1px 1px rgba(255, 255, 255, 0.02);
}

html[data-theme='light'] .view-switcher-premium:hover {
    border-color: rgba(124, 58, 237, 0.15);
    box-shadow: 0 4px 12px rgba(124, 58, 237, 0.04);
}

.btn-switcher-tab {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: 100%;
    padding: 0 1.5rem;
    border-radius: 99px;
    border: 1px solid transparent;
    background: transparent;
    color: var(--text-secondary);
    font-size: 0.85rem;
    font-weight: 600;
    cursor: pointer;
    opacity: 0.65;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    white-space: nowrap;
}

.btn-switcher-tab:hover {
    opacity: 1;
    color: var(--text-primary);
    background: rgba(255, 255, 255, 0.03);
}

html[data-theme='light'] .btn-switcher-tab:hover {
    background: rgba(0, 0, 0, 0.02);
}

/* Active Segment Highlight: glossy glassmorphism, LED border glow, elevated surface */
.btn-switcher-tab.active {
    opacity: 1;
    color: #ffffff !important;
    background: linear-gradient(135deg, rgba(168, 85, 247, 0.28) 0%, rgba(99, 102, 241, 0.24) 100%) !important;
    border: 1px solid rgba(168, 85, 247, 0.6) !important;
    box-shadow:
        0 0 12px rgba(168, 85, 247, 0.35),
        0 4px 10px rgba(0, 0, 0, 0.25),
        inset 0 1px 0 rgba(255, 255, 255, 0.12) !important;
}

html[data-theme='light'] .btn-switcher-tab.active {
    background: linear-gradient(135deg, rgba(124, 58, 237, 0.16) 0%, rgba(79, 70, 229, 0.16) 100%) !important;
    color: #6d28d9 !important;
    border: 1px solid rgba(124, 58, 237, 0.5) !important;
    box-shadow:
        0 0 10px rgba(124, 58, 237, 0.25),
        0 4px 8px rgba(124, 58, 237, 0.1),
        inset 0 1px 0 rgba(255, 255, 255, 0.2) !important;
}

/* Red/Green LED highlight when Drafts tab has drafts */
.btn-switcher-tab.has-drafts::after {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #10b981;
    box-shadow: 0 0 8px #10b981;
    display: inline-block;
    margin-left: 2px;
}

/* Transition Blur effect for table container */
.dms-table-container {
    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.dms-table-container.transition-blur {
    opacity: 0;
    filter: blur(8px);
    transform: scale(0.98);
}

/* --- Page Container & Global Depth --- */
.dms-connections-container {
    max-width: 1800px;
    margin: 0;
    padding: 0 0 4rem;
    position: relative;
    z-index: 1;
}

/* Subtle Data Grid Background Pattern */
.dms-connections-container::before {
    content: '';
    position: absolute;
    inset: -20px;
    background-image:
        linear-gradient(rgba(0, 0, 0, 0.02) 1px, transparent 1px),
        linear-gradient(90deg, rgba(0, 0, 0, 0.02) 1px, transparent 1px);
    background-size: 50px 50px;
    mask-image: radial-gradient(circle at center, black 0%, transparent 80%);
    pointer-events: none;
    z-index: -1;
}

html[data-theme="dark"] .dms-connections-container::before {
    background-image:
        linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
        linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
}

/* Header classes removed in favor of global dms-page-header in EnterpriseDMS.css */

.header-actions-premium {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 1.5rem;
}

/* Premium Add Button */
.btn-add-nexus {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    background: var(--gradient-main);
    color: white;
    padding: 0.85rem 2.25rem;
    border-radius: 16px;
    font-weight: 600;
    font-size: 1rem;
    border: none;
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    box-shadow: 0 10px 30px rgba(99, 102, 241, 0.3);
}

.btn-add-nexus:hover {
    transform: translateY(-4px) scale(1.02);
    box-shadow: 0 20px 45px rgba(99, 102, 241, 0.4);
}

/* Premium Delete Selected Button */
.btn-delete-selected-nexus {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    background: #ef4444;
    color: white;
    padding: 0.85rem 2.25rem;
    border-radius: 16px;
    font-weight: 600;
    font-size: 1rem;
    border: none;
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    box-shadow: 0 10px 30px rgba(239, 68, 68, 0.3);
}

.btn-delete-selected-nexus:hover {
    transform: translateY(-4px) scale(1.02);
    background: #dc2626;
    box-shadow: 0 20px 45px rgba(239, 68, 68, 0.4);
}

/* â”€â”€ Context-Aware Help Popover â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */

.field-info-btn {
    border-radius: 50%;
    padding: 2px !important;
}

.field-info-btn:hover,
.field-info-btn.active {
    color: var(--primary, #7c3aed) !important;
    background: rgba(124, 58, 237, 0.1);
}

.help-popover-card {
    position: absolute;
    top: calc(100% + 12px);
    left: -16px;
    width: 320px;
    z-index: 1000;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    animation: popoverFadeIn 0.2s cubic-bezier(0.16, 1, 0.3, 1) forwards;
    cursor: default;
}

[data-theme='dark'] .help-popover-card {
    background: #1e293b;
    border: 1px solid #334155;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.4);
}

.help-popover-arrow {
    position: absolute;
    top: -6px;
    left: 24px;
    width: 12px;
    height: 12px;
    background: #ffffff;
    border-top: 1px solid #e2e8f0;
    border-left: 1px solid #e2e8f0;
    transform: rotate(45deg);
    z-index: 1001;
}

[data-theme='dark'] .help-popover-arrow {
    background: #1e293b;
    border-top: 1px solid #334155;
    border-left: 1px solid #334155;
}

.help-popover-content {
    padding: 1.25rem;
    position: relative;
    z-index: 1002;
    background: transparent;
}

.help-popover-content h3 {
    margin: 0 0 1rem 0;
    font-size: 0.9rem;
    font-weight: 700;
    color: var(--text-primary, #0f172a);
}

.help-popover-steps {
    margin: 0;
    padding-left: 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.help-popover-steps li {
    font-size: 0.8rem;
    line-height: 1.4;
    color: #475569;
}

[data-theme='dark'] .help-popover-steps li {
    color: #94a3b8;
}

@keyframes popoverFadeIn {
    from {
        opacity: 0;
        transform: translateY(4px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.form-control:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* Styling for migration table checkboxes */
.dms-checkbox {
    width: 14px;
    height: 14px;
    min-width: 14px;
    min-height: 14px;
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    cursor: pointer;
    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.4);
    border-radius: 2px;
    accent-color: #3b82f6;
}

html[data-theme='light'] .dms-checkbox {
    box-shadow: 0 0 0 1px #d1d5db;
    background-color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/components/dms/DMSWizard.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC;IACI,6CAA6C;IAC7C,qCAAqC;AACzC;;AAEA;;IAEI,gDAAgD;AACpD;;AAEA;IACI,kBAAkB;IAClB,iDAAiD;IACjD,gCAAgC;IAChC,2EAA2E;IAC3E,uCAAuC;IACvC,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB;gDAC4C;IAC5C,gBAAgB;AACpB;;AAEA;;IAEI,wEAAwE;IACxE,gCAAgC;IAChC,qEAAqE;IACrE,uCAAuC;IACvC;iDAC6C;AACjD;;AAEA;IACI,oBAAoB;IACpB,6DAA6D;IAC7D,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;;IAEI,kCAAkC;IAClC,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,SAAO;IACP,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;IACI,YAAY;IACZ,cAAc;IACd,kCAAkC;IAClC,4DAA4D;IAC5D,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;;IAEI,kCAAkC;IAClC,2EAA2E;AAC/E;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA,wDAAwD;;AAExD;IACI,8CAA8C;IAC9C,yBAAyB;IACzB,gBAAgB;IAChB,mDAAmD;AACvD;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,0DAA0D;IAC1D,8CAA8C;IAC9C,yCAAyC;IACzC,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,0DAA0D;IAC1D,wBAAwB;IACxB,gDAAgD;AACpD;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA,sBAAsB;AACtB;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,kCAAkC;IAClC,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA,6BAA6B;AAC7B;;;IAGI,UAAU;IACV,WAAW;AACf;;AAEA;;;IAGI,uBAAuB;AAC3B;;AAEA;;;IAGI,qCAAqC;IACrC,mBAAmB;IACnB,4BAAoB;IAApB,oBAAoB;AACxB;;AAEA;;;IAGI,oCAAoC;AACxC;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,wBAAwB;IACxB,4CAA4C;IAC5C,sBAAsB;IACtB,4DAA4D;IAC5D,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,sDAAsD;AAC1D;;AAEA;;IAEI,gEAAgE;IAChE,qEAAqE;IACrE,sCAAsC;IACtC,qDAAqD;AACzD;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,8CAA8C;IAC9C,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,gCAAgC;AACpC;;AAEA;;;IAGI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,wEAAwE;IACxE,uBAAuB;IACvB,oCAAoC;IACpC,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iDAAiD;IACjD,iGAAiG;IACjG,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;;;IAGI,2BAA2B;IAC3B,wEAAwE;IACxE,iGAAiG;AACrG;;AAEA;;;IAGI,8BAA8B;IAC9B,yDAAyD;IACzD,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iDAAiD;IACjD,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;IAC5C,2BAA2B;AAC/B;;AAEA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,YAAY;IACZ,4BAA4B;IAC5B,sBAAsB;IACtB,eAAe;IACf,oBAAoB;IACpB,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;IAC1B,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;;;IAGI,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,qCAAqC;IACrC,qBAAqB;IACrB,+CAA+C;AACnD;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,wDAAwD;AAC5D;;AAEA,wBAAwB;AACxB;IACI,wEAAwE;IACxE,2EAA2E;IAC3E,gCAAgC;IAChC;gDAC4C;AAChD;;AAEA;IACI,kCAAkC;IAClC,2CAA2C;AAC/C;;AAEA;IACI,6DAA6D;IAC7D,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,kCAAkC;IAClC,iFAAiF;AACrF;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,0BAA0B;IAC1B,wEAAwE;AAC5E;;AAEA;IACI,iCAAiC;IACjC,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,2EAA2E;IAC3E,gCAAgC;IAChC,oDAAoD;AACxD;;AAEA;IACI,8BAA8B;IAC9B,iDAAiD;IACjD,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,qCAAqC;IACrC,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,6CAA6C;IAC7C,+CAA+C;AACnD;;AAEA;;IAEI,8BAA8B;IAC9B,gCAAgC;IAChC,yBAAyB;IACzB,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,yDAAyD;AAC7D;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,uBAAuB;AAC3B;;AAEA;IACI,UAAU;AACd;;AAEA,kCAAkC;AAClC;IACI,mBAAmB;IACnB,2CAA2C;IAC3C,2CAA2C;AAC/C;;AAEA;IACI,4CAA4C;IAC5C,sDAAsD;IACtD,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA,kBAAkB;AAClB;IACI,6DAA6D;IAC7D,yBAAyB;IACzB,+CAA+C;AACnD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,8CAA8C;IAC9C,oDAAoD;IACpD,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,iBAAiB;AACjB;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,8CAA8C;IAC9C,oDAAoD;IACpD,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,eAAe;AACf;IACI;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB,kBAAkB;QAClB,4CAA4C;QAC5C,mBAAmB;QACnB,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA,eAAe;AACf;IACI;QACI,sBAAsB;QACtB,UAAU;IACd;;IAEA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,kCAAkC;AACtC;;AAEA,yBAAyB;AACzB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,0CAA0C;IAC1C,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;;IAEA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,4CAA4C;IAC5C,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,0BAA0B;IAC1B,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,sBAAsB;IACtB,mCAAmC;IACnC,8BAA8B;IAC9B,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,yCAAyC;IACzC,+BAA+B;IAC/B,aAAa;IACb,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,qCAAqC;IACrC,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;IAC3B,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,4CAA4C;IAC5C,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mCAAmC;IACnC,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,0BAA0B;IAC1B,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,sBAAsB;IACtB,mCAAmC;IACnC,8BAA8B;IAC9B,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,yCAAyC;IACzC,+BAA+B;IAC/B,aAAa;IACb,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,qCAAqC;IACrC,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;IAC3B,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;+EAE+E;;AAE/E;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;IACZ,+BAA+B;IAC/B,qBAAqB;IACrB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI;QACI,sBAAsB;QACtB,oBAAoB;QACpB,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,SAAO;IACX;AACJ;;AAEA,uCAAuC;AACvC;IACI,kBAAkB;IAClB,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,mDAAmD;IACnD,2BAA2B;IAC3B,gEAAgE;IAChE,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,8CAA8C;IAC9C,kDAAkD;AACtD;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;IACrC,+EAA+E;AACnF;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,SAAO;IACP,uBAAuB;IACvB,kCAAkC;IAClC,qCAAqC;IACrC,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;IACxB,qBAAqB;IACrB,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,wBAAwB;IACxB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,gCAAgC;AAChC;IACI,+CAA+C;IAC/C,yHAAyH;AAC7H;;AAEA;IACI,+CAA+C;IAC/C,8EAA8E;AAClF;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI;QACI,2BAA2B;QAC3B,WAAW;IACf;;IAEA;QACI,SAAO;IACX;;IAEA;QACI,WAAW;QACX,8BAA8B;IAClC;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,2DAA2D;AAC/D;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,qCAAqC;IACrC,2BAA2B;IAC3B,2CAA2C;IAC3C,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kDAAkD;IAClD,0CAA0C;AAC9C;;AAEA;IACI,+BAA+B;IAC/B,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,uCAAuC;IACvC,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,+BAA+B;IAC/B,iCAAiC;IACjC,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,kCAAkC;AAClC;IACI,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;IACR,YAAY;IACZ,kCAAkC;IAClC,0CAA0C;IAC1C,2CAA2C;IAC3C,mBAAmB;IACnB,eAAe;IACf,mFAAmF;IACnF,aAAa;;IAEb,UAAU;IACV,kBAAkB;IAClB,oBAAoB;IACpB,uCAAuC;IACvC,yDAAyD;AAC7D;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,oBAAoB;IACpB,oEAAoE;AACxE;;AAEA;IACI,qCAAqC;IACrC,qCAAqC;IACrC,2CAA2C;AAC/C;;AAEA;IACI;QACI,UAAU;QACV,uCAAuC;IAC3C;;IAEA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,wBAAwB;IACxB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,4CAA4C;AAC5C;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,qCAAqC;IACrC,2BAA2B;IAC3B,mCAAmC;IACnC,2CAA2C;IAC3C,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;IACZ,QAAQ;IACR,qFAAqF;IACrF,kDAAkD;AACtD;;AAEA;IACI,gCAAgC;IAChC,iCAAiC;IACjC,8EAA8E;AAClF;;AAEA,oCAAoC;AACpC;IACI,2BAA2B;IAC3B,qCAAqC;IACrC;;;iDAG6C;AACjD;;AAEA;IACI,sCAAsC;IACtC,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;IAC7B,uBAAuB;IACvB,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,kDAAkD;IAClD,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,0BAA0B;IAC1B,qCAAqC;AACzC;;AAEA;IACI,+BAA+B;AACnC;;AAEA,sFAAsF;AACtF;IACI,UAAU;IACV,yBAAyB;IACzB,0GAA0G;IAC1G,oDAAoD;IACpD;;;0DAGsD;AAC1D;;AAEA;IACI,yGAAyG;IACzG,yBAAyB;IACzB,oDAAoD;IACpD;;;yDAGqD;AACzD;;AAEA,uDAAuD;AACvD;IACI,WAAW;IACX,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;IAC3B,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA,+CAA+C;AAC/C;IACI,kDAAkD;AACtD;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA,0CAA0C;AAC1C;IACI,iBAAiB;IACjB,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;;AAEA,wCAAwC;AACxC;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ;;wEAEoE;IACpE,0BAA0B;IAC1B,wEAAwE;IACxE,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI;;8EAE0E;AAC9E;;AAEA,mFAAmF;;AAEnF;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,WAAW;AACf;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gCAAgC;IAChC,YAAY;IACZ,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,kDAAkD;IAClD,+CAA+C;AACnD;;AAEA;IACI,uCAAuC;IACvC,+CAA+C;AACnD;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,kDAAkD;IAClD,8CAA8C;AAClD;;AAEA;IACI,uCAAuC;IACvC,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA,iLAAiL;;AAEjL;IACI,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;;IAEI,yCAAyC;IACzC,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,2CAA2C;IAC3C,aAAa;IACb,sBAAsB;IACtB,oEAAoE;IACpE,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;IAC7B,8BAA8B;IAC9B,wBAAwB;IACxB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;IACI,SAAS;IACT,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,UAAU;QACV,0BAA0B;IAC9B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,2CAA2C;AAC3C;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,sBAAsB;IACtB,eAAe;IACf,8CAA8C;IAC9C,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;AAC7B","sourcesContent":["/* Google Cloud DMS-Style Wizard */\n\n.wizard-modal-overlay {\n    background: rgba(10, 15, 30, 0.75) !important;\n    backdrop-filter: blur(8px) !important;\n}\n\nhtml[data-theme='light'] .wizard-modal-overlay,\n[data-theme='light'] .wizard-modal-overlay {\n    background: rgba(232, 236, 248, 0.65) !important;\n}\n\n.wizard-modal {\n    position: relative;\n    background: var(--bg-primary, #0d1127) !important;\n    backdrop-filter: none !important;\n    border: 1px solid var(--glass-border, rgba(255, 255, 255, 0.05)) !important;\n    background-clip: padding-box !important;\n    border-radius: 24px;\n    width: 95vw;\n    max-width: 1240px;\n    height: 92vh;\n    max-height: 92vh;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3),\n        0 8px 18px rgba(0, 0, 0, 0.2) !important;\n    overflow: hidden;\n}\n\nhtml[data-theme='light'] .wizard-modal,\n[data-theme='light'] .wizard-modal {\n    background: linear-gradient(135deg, #eaedfa 0%, #dbe0f5 100%) !important;\n    backdrop-filter: none !important;\n    border: 1px solid var(--glass-border, rgba(0, 0, 0, 0.05)) !important;\n    background-clip: padding-box !important;\n    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.04),\n        0 4px 10px rgba(0, 0, 0, 0.02) !important;\n}\n\n.wizard-header {\n    padding: 1.5rem 3rem;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: transparent !important;\n}\n\nhtml[data-theme='light'] .wizard-header,\n[data-theme='light'] .wizard-header {\n    background: transparent !important;\n    border-bottom: 1px solid #E3E6EF !important;\n}\n\n.wizard-body {\n    display: flex;\n    flex: 1;\n    overflow: hidden;\n}\n\n/* Left Sidebar */\n.wizard-sidebar {\n    width: 320px;\n    flex-shrink: 0;\n    background: transparent !important;\n    border-right: 1px solid rgba(255, 255, 255, 0.05) !important;\n    padding: 2.5rem 1.5rem;\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n}\n\nhtml[data-theme='light'] .wizard-sidebar,\n[data-theme='light'] .wizard-sidebar {\n    background: transparent !important;\n    border-right: 1px solid var(--glass-border, rgba(0, 0, 0, 0.05)) !important;\n}\n\n.wizard-sidebar-actions {\n    margin-top: auto;\n    padding: 1rem 0;\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n    border-top: 1px solid var(--border-color);\n}\n\n.wizard-sidebar-actions button {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    padding: 0.75rem 1rem;\n    border-radius: 10px;\n    font-size: 0.9rem;\n    cursor: pointer;\n    transition: all 0.2s;\n    text-align: left;\n    margin-bottom: 0.5rem;\n    border: 1px solid transparent;\n}\n\n/* Replaced btn-save to be glossy navy blue down below */\n\n.wizard-sidebar-actions .btn-discard {\n    background: rgba(239, 68, 68, 0.05) !important;\n    color: #ef4444 !important;\n    font-weight: 500;\n    border: 1px solid rgba(239, 68, 68, 0.1) !important;\n}\n\n.wizard-sidebar-actions .btn-discard:hover {\n    background: rgba(239, 68, 68, 0.1) !important;\n}\n\n.wizard-step-item {\n    display: flex;\n    gap: 0.75rem;\n    padding: 0.875rem;\n    margin-bottom: 0.5rem;\n    border-radius: 8px;\n    transition: all 0.2s;\n    cursor: default;\n}\n\n.wizard-step-item.pending {\n    opacity: 0.5;\n}\n\n.wizard-step-item.active {\n    background: var(--bg-button-secondary, #EEF1F8) !important;\n    border-left: 4px solid var(--primary, #6366f1);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);\n    transform: translateX(5px);\n}\n\n.wizard-step-item.completed {\n    opacity: 0.8;\n}\n\n.wizard-step-item .step-number {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.75rem;\n    font-weight: 700;\n    flex-shrink: 0;\n    background: var(--bg-button-secondary, #ffffff) !important;\n    color: var(--text-muted);\n    border: 2px solid var(--border-color) !important;\n}\n\n.wizard-step-item.active .step-number {\n    background: #7c3aed !important;\n    color: white !important;\n    border-color: #7c3aed !important;\n}\n\n.wizard-step-item.completed .step-number {\n    background: #10b981 !important;\n    color: white !important;\n    border-color: #10b981 !important;\n}\n\n.wizard-step-item .step-content {\n    flex: 1;\n    min-width: 0;\n}\n\n.wizard-step-item .step-title {\n    font-size: 0.9375rem;\n    font-weight: 500;\n    color: var(--text-primary);\n    margin-bottom: 0.25rem;\n}\n\n.wizard-step-item .step-subtitle {\n    font-size: 0.8125rem;\n    color: var(--text-muted);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.wizard-sidebar-actions {\n    margin-top: auto;\n    padding-top: 1.5rem;\n    border-top: 1px solid var(--border-color);\n}\n\n/* Main Content Area */\n.wizard-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n    overflow-x: hidden;\n    /* Hide the thick horizontal bar */\n    min-width: 0;\n    position: relative;\n    background: transparent;\n}\n\n/* Refined Modern Scrollbar */\n.wizard-content::-webkit-scrollbar,\n.wizard-sidebar::-webkit-scrollbar,\n.step-body::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n}\n\n.wizard-content::-webkit-scrollbar-track,\n.wizard-sidebar::-webkit-scrollbar-track,\n.step-body::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.wizard-content::-webkit-scrollbar-thumb,\n.wizard-sidebar::-webkit-scrollbar-thumb,\n.step-body::-webkit-scrollbar-thumb {\n    background: rgba(102, 126, 234, 0.15);\n    border-radius: 20px;\n    transition: all 0.3s;\n}\n\n.wizard-content::-webkit-scrollbar-thumb:hover,\n.wizard-sidebar::-webkit-scrollbar-thumb:hover,\n.step-body::-webkit-scrollbar-thumb:hover {\n    background: rgba(102, 126, 234, 0.4);\n}\n\n.wizard-step-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    padding: 2.5rem 3rem;\n    width: calc(100% - 3rem);\n    /* Ensure consistent margins on both sides */\n    box-sizing: border-box;\n    background: var(--bg-card, rgba(20, 26, 48, 0.4)) !important;\n    margin: 1.5rem;\n    border-radius: 24px;\n    box-shadow: none;\n    border: 1px solid rgba(255, 255, 255, 0.05) !important;\n}\n\nhtml[data-theme='light'] .wizard-step-content,\n[data-theme='light'] .wizard-step-content {\n    background: var(--bg-card, rgba(255, 255, 255, 0.75)) !important;\n    border: 1px solid var(--glass-border, rgba(0, 0, 0, 0.05)) !important;\n    backdrop-filter: blur(12px) !important;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02) !important;\n}\n\n.step-header {\n    margin-bottom: 2rem;\n    flex-shrink: 0;\n}\n\n.step-header h3 {\n    font-size: 1.5rem;\n    font-weight: 600;\n    color: var(--text-primary);\n    margin-bottom: 0.5rem;\n    margin-top: 0;\n}\n\n.step-header p {\n    font-size: 0.9375rem;\n    color: var(--text-muted);\n    margin: 0;\n}\n\n.step-body {\n    flex: 1;\n    overflow-y: auto;\n}\n\n.step-footer {\n    padding-top: 1.5rem;\n    border-top: 1px solid rgba(102, 126, 234, 0.1);\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    margin-top: auto;\n    background: transparent;\n    gap: 1.25rem;\n    /* Added space between buttons */\n}\n\n.step-footer .btn-primary,\n.wizard-sidebar-actions .btn-primary,\n.wizard-sidebar-actions .btn-save {\n    min-width: 140px;\n    height: 46px;\n    padding: 0 1.75rem;\n    background: linear-gradient(180deg, #1e3a8a 0%, #172554 100%) !important;\n    color: white !important;\n    border: 1px solid #0f172a !important;\n    border-radius: 12px;\n    font-weight: 700;\n    font-size: 0.95rem;\n    cursor: pointer;\n    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n    box-shadow: inset 0 2px 4px rgba(255, 255, 255, 0.2), 0 4px 10px rgba(15, 23, 42, 0.4) !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n.step-footer .btn-primary:hover:not(:disabled),\n.wizard-sidebar-actions .btn-primary:hover:not(:disabled),\n.wizard-sidebar-actions .btn-save:hover:not(:disabled) {\n    transform: translateY(-2px);\n    background: linear-gradient(180deg, #2563eb 0%, #1e3a8a 100%) !important;\n    box-shadow: inset 0 2px 4px rgba(255, 255, 255, 0.3), 0 6px 15px rgba(15, 23, 42, 0.5) !important;\n}\n\n.step-footer .btn-primary:active:not(:disabled),\n.wizard-sidebar-actions .btn-primary:active:not(:disabled),\n.wizard-sidebar-actions .btn-save:active:not(:disabled) {\n    background: #0f172a !important;\n    box-shadow: inset 0 3px 6px rgba(0, 0, 0, 0.5) !important;\n    transform: translateY(0);\n}\n\n.step-footer .btn-secondary {\n    min-width: 140px;\n    height: 46px;\n    padding: 0 1.5rem;\n    border-radius: 12px;\n    font-weight: 600;\n    font-size: 0.95rem;\n    cursor: pointer;\n    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\nhtml[data-theme='light'] .step-footer .btn-secondary {\n    background: #ffffff;\n    border: 1px solid #2563EB;\n    color: #2563EB;\n}\n\nhtml[data-theme='light'] .step-footer .btn-secondary:hover:not(:disabled) {\n    background: #EFF6FF;\n    border-color: #1D4ED8;\n    color: #1D4ED8;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 15px rgba(37, 99, 235, 0.2);\n}\n\n[data-theme='dark'] .step-footer .btn-secondary {\n    background: #0F172A;\n    border: 1px solid #3B82F6;\n    color: #60A5FA;\n}\n\n[data-theme='dark'] .step-footer .btn-secondary:hover:not(:disabled) {\n    border-color: #60A5FA;\n    box-shadow: 0 0 12px rgba(59, 130, 246, 0.4);\n    transform: translateY(-2px);\n}\n\n/* Button Styles */\n.btn-text {\n    background: none;\n    border: none;\n    color: var(--text-secondary);\n    padding: 0.625rem 1rem;\n    cursor: pointer;\n    font-size: 0.9375rem;\n    transition: all 0.2s;\n}\n\n.btn-text:hover {\n    color: var(--text-primary);\n    background: rgba(255, 255, 255, 0.05);\n    border-radius: 6px;\n}\n\n.btn-text:disabled,\n.btn-primary:disabled,\n.btn-secondary:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    filter: grayscale(0.5);\n    box-shadow: none !important;\n    transform: none !important;\n}\n\n.form-control:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.wizard-modal .form-control {\n    background: #F6F7FB !important;\n    border: 1px solid #E3E6EF !important;\n    color: var(--text-primary) !important;\n    backdrop-filter: none;\n    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.02);\n}\n\n.wizard-modal .form-control:focus {\n    background: #ffffff !important;\n    border-color: #6366f1 !important;\n    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1) !important;\n}\n\n/* Dark Mode Overrides */\n[data-theme='dark'] .wizard-modal {\n    background: linear-gradient(135deg, #10142A 0%, #1C2340 100%) !important;\n    border: 1px solid var(--glass-border, rgba(255, 255, 255, 0.05)) !important;\n    backdrop-filter: none !important;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4),\n        0 8px 18px rgba(0, 0, 0, 0.2) !important;\n}\n\n[data-theme='dark'] .wizard-header {\n    background: transparent !important;\n    border-bottom: 1px solid #1e2542 !important;\n}\n\n[data-theme='dark'] .wizard-header h2 {\n    background: linear-gradient(135deg, #f8fafc 0%, #a5b4fc 100%);\n    -webkit-background-clip: text;\n    background-clip: text;\n}\n\n[data-theme='dark'] .wizard-sidebar {\n    background: transparent !important;\n    border-right: 1px solid var(--glass-border, rgba(255, 255, 255, 0.05)) !important;\n}\n\n[data-theme='dark'] .wizard-step-item .step-title {\n    color: #f8fafc;\n}\n\n[data-theme='dark'] .wizard-step-item .step-subtitle {\n    color: #cbd5e1;\n}\n\n[data-theme='dark'] .wizard-step-item.active {\n    background: rgba(99, 102, 241, 0.16);\n    border-left-color: #8b5cf6;\n    box-shadow: 0 4px 15px rgba(139, 92, 246, 0.15), var(--glass-inner-glow);\n}\n\n[data-theme='dark'] .wizard-step-item .step-number {\n    background: rgba(15, 22, 42, 0.6);\n    border-color: rgba(255, 255, 255, 0.1);\n    color: #cbd5e1;\n}\n\n[data-theme='dark'] .wizard-step-content {\n    background: #1A1F36 !important;\n    border: 1px solid var(--glass-border, rgba(255, 255, 255, 0.08)) !important;\n    backdrop-filter: none !important;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2) !important;\n}\n\n[data-theme='dark'] .wizard-modal .form-control {\n    background: #121625 !important;\n    border-color: rgba(255, 255, 255, 0.1) !important;\n    color: #f8fafc !important;\n}\n\n[data-theme='dark'] .step-header h3 {\n    color: #ffffff;\n}\n\n[data-theme='dark'] .step-header p {\n    color: #94a3b8;\n}\n\n[data-theme='dark'] .step-footer {\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n[data-theme='dark'] .step-footer .btn-secondary {\n    background: rgba(255, 255, 255, 0.03);\n    border-color: rgba(255, 255, 255, 0.1);\n    color: #cbd5e1;\n}\n\n[data-theme='dark'] .step-footer .btn-secondary:hover {\n    background: rgba(255, 255, 255, 0.08);\n    border-color: #a855f7;\n    color: #ffffff;\n}\n\n[data-theme='dark'] .wizard-sidebar-actions .btn-discard {\n    background: rgba(239, 68, 68, 0.1) !important;\n    border-color: rgba(239, 68, 68, 0.2) !important;\n}\n\n[data-theme='dark'] .wizard-modal .form-control,\n[data-theme='dark'] .form-control {\n    background: #182040 !important;\n    border-color: #252e52 !important;\n    color: #ffffff !important;\n    backdrop-filter: none;\n    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n[data-theme='dark'] .wizard-modal .form-control:focus {\n    background: #1b2548 !important;\n    border-color: #8b5cf6 !important;\n    box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.15) !important;\n}\n\n[data-theme='dark'] label {\n    color: #e2e8f0 !important;\n}\n\n[data-theme='dark'] .wizard-step-item.completed .step-number {\n    background: #10b981 !important;\n    border-color: #10b981 !important;\n    color: white !important;\n}\n\n[data-theme='dark'] .wizard-step-item.completed {\n    opacity: 1;\n}\n\n/* Theme-aware Connectivity Card */\n.connectivity-card {\n    background: #ffffff;\n    border: 1px solid rgba(102, 126, 234, 0.15);\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.06);\n}\n\n[data-theme='dark'] .connectivity-card {\n    background: rgba(30, 41, 59, 0.5) !important;\n    border: 1px solid rgba(255, 255, 255, 0.08) !important;\n    box-shadow: none !important;\n    backdrop-filter: blur(10px);\n}\n\n/* Runner IP Box */\n.runner-ip-box {\n    background: linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%);\n    border: 2px solid #ddd6fe;\n    box-shadow: 0 8px 20px rgba(124, 58, 237, 0.08);\n}\n\n.runner-ip-box code {\n    color: #1f2937;\n}\n\n[data-theme='dark'] .runner-ip-box {\n    background: rgba(99, 102, 241, 0.1) !important;\n    border: 1px solid rgba(99, 102, 241, 0.2) !important;\n    box-shadow: none !important;\n}\n\n[data-theme='dark'] .runner-ip-box code {\n    color: #ffffff !important;\n}\n\n/* Info/Tip Box */\n.info-box {\n    background: #eff6ff;\n    border: 1px solid #bfdbfe;\n    color: #1e40af;\n}\n\n[data-theme='dark'] .info-box {\n    background: rgba(59, 130, 246, 0.1) !important;\n    border: 1px solid rgba(59, 130, 246, 0.2) !important;\n    color: #93c5fd !important;\n}\n\n[data-theme='dark'] .connectivity-text {\n    color: #94a3b8 !important;\n}\n\n[data-theme='dark'] .wizard-content {\n    background: transparent !important;\n}\n\n[data-theme='dark'] .step-body {\n    background: transparent;\n}\n\n/* Responsive */\n@media (max-width: 968px) {\n    .wizard-modal {\n        width: 98vw;\n        max-height: 95vh;\n    }\n\n    .wizard-sidebar {\n        width: 240px;\n    }\n\n    .wizard-step-content {\n        padding: 1.5rem;\n    }\n}\n\n@media (max-width: 768px) {\n    .wizard-body {\n        flex-direction: column;\n    }\n\n    .wizard-sidebar {\n        width: 100%;\n        max-height: 200px;\n        border-right: none;\n        border-bottom: 1px solid var(--border-color);\n        flex-direction: row;\n        overflow-x: auto;\n        padding: 1rem;\n    }\n\n    .wizard-step-item {\n        flex-direction: column;\n        align-items: center;\n        text-align: center;\n        min-width: 120px;\n    }\n\n    .wizard-sidebar-actions {\n        display: none;\n    }\n}\n\n/* Animations */\n@keyframes scaleUp {\n    from {\n        transform: scale(0.95);\n        opacity: 0;\n    }\n\n    to {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n\n@keyframes spin {\n    from {\n        transform: rotate(0deg);\n    }\n\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.spin {\n    animation: spin 1s linear infinite;\n}\n\n/* Cutover Modal Styles */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    backdrop-filter: blur(4px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 10000;\n    animation: fadeIn 0.2s ease-out;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n.modal-content {\n    background: var(--bg-primary);\n    border-radius: 12px;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n    max-width: 90vw;\n    max-height: 90vh;\n    overflow: hidden;\n    animation: slideUp 0.3s ease-out;\n}\n\n@keyframes slideUp {\n    from {\n        transform: translateY(20px);\n        opacity: 0;\n    }\n\n    to {\n        transform: translateY(0);\n        opacity: 1;\n    }\n}\n\n.cutover-modal {\n    max-width: 520px !important;\n}\n\n.cutover-modal .modal-header {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    padding: 1.5rem 1.75rem;\n    border-bottom: 1px solid var(--border-color);\n    background: var(--bg-secondary);\n}\n\n.cutover-modal .modal-icon.warning {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background: rgba(245, 158, 11, 0.15);\n    color: #f59e0b;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.cutover-modal .modal-header h3 {\n    flex: 1;\n    margin: 0;\n    font-size: 1.125rem;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.cutover-modal .modal-close {\n    background: none;\n    border: none;\n    color: var(--text-muted);\n    cursor: pointer;\n    padding: 0.5rem;\n    border-radius: 6px;\n    transition: all 0.2s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.cutover-modal .modal-close:hover {\n    background: rgba(0, 0, 0, 0.05);\n    color: var(--text-primary);\n}\n\n[data-theme='dark'] .cutover-modal .modal-close:hover {\n    background: rgba(255, 255, 255, 0.05);\n}\n\n.cutover-modal .modal-body {\n    padding: 1.75rem;\n}\n\n.cutover-modal .warning-text {\n    font-size: 0.9375rem;\n    color: var(--text-primary);\n    margin: 0 0 1.25rem 0;\n    font-weight: 500;\n}\n\n.cutover-modal .cutover-steps {\n    margin: 0 0 1.5rem 0;\n    padding-left: 1.25rem;\n    color: var(--text-secondary);\n    list-style: decimal;\n}\n\n.cutover-modal .cutover-steps li {\n    margin: 0.625rem 0;\n    font-size: 0.875rem;\n    line-height: 1.5;\n    padding-left: 0.5rem;\n}\n\n.cutover-modal .danger-text {\n    margin: 0;\n    padding: 0.875rem 1rem;\n    background: rgba(239, 68, 68, 0.08);\n    border-left: 3px solid #ef4444;\n    border-radius: 6px;\n    color: #ef4444;\n    font-weight: 500;\n    font-size: 0.875rem;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.cutover-modal .modal-footer {\n    padding: 1.25rem 1.75rem;\n    border-top: 1px solid var(--border-color);\n    background: var(--bg-secondary);\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.75rem;\n}\n\n.cutover-modal .modal-footer .btn-secondary {\n    background: var(--bg-primary);\n    color: var(--text-primary);\n    border: 1px solid var(--border-color);\n    padding: 0.625rem 1.25rem;\n    border-radius: 6px;\n    font-weight: 500;\n    font-size: 0.875rem;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.cutover-modal .modal-footer .btn-secondary:hover {\n    background: var(--bg-input);\n    border-color: var(--text-muted);\n}\n\n.cutover-modal .btn-danger {\n    background: #ef4444;\n    color: white;\n    border: none;\n    padding: 0.625rem 1.5rem;\n    border-radius: 6px;\n    font-weight: 500;\n    font-size: 0.875rem;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.cutover-modal .btn-danger:hover {\n    background: #dc2626;\n    box-shadow: 0 2px 8px rgba(239, 68, 68, 0.25);\n}\n\n.cutover-modal .btn-danger:active {\n    transform: translateY(1px);\n}\n\n.stop-modal {\n    max-width: 520px !important;\n}\n\n.stop-modal .modal-header {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    padding: 1.5rem 1.75rem;\n    border-bottom: 1px solid var(--border-color);\n    background: var(--bg-secondary);\n}\n\n.stop-modal .modal-icon.danger {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background: rgba(239, 68, 68, 0.15);\n    color: #ef4444;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.stop-modal .modal-header h3 {\n    flex: 1;\n    margin: 0;\n    font-size: 1.125rem;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.stop-modal .modal-close {\n    background: none;\n    border: none;\n    color: var(--text-muted);\n    cursor: pointer;\n    padding: 0.5rem;\n    border-radius: 6px;\n    transition: all 0.2s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.stop-modal .modal-close:hover {\n    background: rgba(0, 0, 0, 0.05);\n    color: var(--text-primary);\n}\n\n[data-theme='dark'] .stop-modal .modal-close:hover {\n    background: rgba(255, 255, 255, 0.05);\n}\n\n.stop-modal .modal-body {\n    padding: 1.75rem;\n}\n\n.stop-modal .warning-text {\n    font-size: 0.9375rem;\n    color: var(--text-primary);\n    margin: 0 0 1.25rem 0;\n    font-weight: 500;\n}\n\n.stop-modal .danger-text {\n    margin: 0;\n    padding: 0.875rem 1rem;\n    background: rgba(239, 68, 68, 0.08);\n    border-left: 3px solid #ef4444;\n    border-radius: 6px;\n    color: #ef4444;\n    font-weight: 500;\n    font-size: 0.875rem;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.stop-modal .modal-footer {\n    padding: 1.25rem 1.75rem;\n    border-top: 1px solid var(--border-color);\n    background: var(--bg-secondary);\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.75rem;\n}\n\n.stop-modal .modal-footer .btn-secondary {\n    background: var(--bg-primary);\n    color: var(--text-primary);\n    border: 1px solid var(--border-color);\n    padding: 0.625rem 1.25rem;\n    border-radius: 6px;\n    font-weight: 500;\n    font-size: 0.875rem;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.stop-modal .modal-footer .btn-secondary:hover {\n    background: var(--bg-input);\n    border-color: var(--text-muted);\n}\n\n.stop-modal .btn-danger {\n    background: #ef4444;\n    color: white;\n    border: none;\n    padding: 0.625rem 1.5rem;\n    border-radius: 6px;\n    font-weight: 500;\n    font-size: 0.875rem;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.stop-modal .btn-danger:hover {\n    background: #dc2626;\n    box-shadow: 0 2px 8px rgba(239, 68, 68, 0.25);\n}\n\n.stop-modal .btn-danger:active {\n    transform: translateY(1px);\n}\n\n/* ==========================================================================\n   PREMIUM TOOLBAR SECTION (Search, Filter, Sort, View Switcher)\n   ========================================================================== */\n\n.connections-toolbar-premium {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 0.75rem;\n    /* 12px gaps between controls */\n    margin-bottom: 2.5rem;\n    padding: 0.5rem 0.5rem;\n    width: 100%;\n}\n\n@media (max-width: 768px) {\n    .connections-toolbar-premium {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 1rem;\n    }\n\n    .view-switcher-premium {\n        width: 100%;\n    }\n\n    .btn-switcher-tab {\n        flex: 1;\n    }\n}\n\n/* --- Search Bar Glass Container --- */\n.search-bar-glass-container {\n    position: relative;\n    flex: 1;\n    display: flex;\n    align-items: center;\n    max-width: none;\n    background: var(--bg-input, rgba(10, 12, 24, 0.45));\n    backdrop-filter: blur(20px);\n    border: 1px solid var(--border-glass, rgba(255, 255, 255, 0.08));\n    border-radius: 12px;\n    padding: 0 0.85rem;\n    height: 42px;\n    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);\n    transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\nhtml[data-theme='light'] .search-bar-glass-container {\n    background: #ffffff;\n    border: 1px solid rgba(0, 0, 0, 0.08);\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.02), 0 4px 15px rgba(0, 0, 0, 0.02);\n}\n\n.search-icon-dim {\n    color: var(--text-muted);\n    margin-right: 0.75rem;\n    pointer-events: none;\n    transition: color 0.28s;\n}\n\ninput[type=\"text\"].search-input-glass {\n    flex: 1;\n    border: none !important;\n    background: transparent !important;\n    color: var(--text-primary) !important;\n    font-size: 0.9rem !important;\n    font-weight: 500 !important;\n    outline: none !important;\n    padding: 0 !important;\n    height: 100% !important;\n    box-shadow: none !important;\n    border-radius: 0 !important;\n}\n\n.search-input-glass::placeholder {\n    color: var(--text-muted);\n    opacity: 0.7;\n}\n\n.clear-search-btn {\n    border: none;\n    background: transparent;\n    color: var(--text-muted);\n    font-size: 1.2rem;\n    cursor: pointer;\n    padding: 0 4px;\n    transition: color 0.2s;\n    line-height: 1;\n    display: flex;\n    align-items: center;\n}\n\n.clear-search-btn:hover {\n    color: var(--text-primary);\n}\n\n/* Focus State: Soft Cyan Glow */\n.search-bar-glass-container:focus-within {\n    border-color: rgba(6, 182, 212, 0.5) !important;\n    box-shadow: 0 0 0 1px rgba(6, 182, 212, 0.2), 0 0 15px rgba(6, 182, 212, 0.15), inset 0 1px 1px rgba(255, 255, 255, 0.05);\n}\n\nhtml[data-theme='light'] .search-bar-glass-container:focus-within {\n    border-color: rgba(6, 182, 212, 0.6) !important;\n    box-shadow: 0 0 0 1px rgba(6, 182, 212, 0.2), 0 0 12px rgba(6, 182, 212, 0.12);\n}\n\n/* --- Dropdown controls --- */\n.toolbar-actions-group {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n}\n\n@media (max-width: 768px) {\n    .toolbar-actions-group {\n        justify-content: flex-start;\n        width: 100%;\n    }\n\n    .toolbar-dropdown-container {\n        flex: 1;\n    }\n\n    .btn-toolbar-dropdown {\n        width: 100%;\n        justify-content: space-between;\n    }\n}\n\n.toolbar-dropdown-container {\n    position: relative;\n    z-index: 200;\n    /* Ensure dropdown displays above table container content */\n}\n\n.btn-toolbar-dropdown {\n    display: flex;\n    align-items: center;\n    gap: 0.6rem;\n    height: 42px;\n    padding: 0 1.1rem;\n    border-radius: 12px;\n    background: rgba(255, 255, 255, 0.03);\n    backdrop-filter: blur(16px);\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    color: var(--text-secondary);\n    font-size: 0.82rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);\n}\n\nhtml[data-theme='light'] .btn-toolbar-dropdown {\n    background: rgba(0, 0, 0, 0.01);\n    border: 1px solid rgba(0, 0, 0, 0.06);\n    color: #4b5563;\n}\n\n.btn-toolbar-dropdown:hover {\n    background: rgba(255, 255, 255, 0.06);\n    border-color: rgba(255, 255, 255, 0.12);\n    color: var(--text-primary);\n    transform: translateY(-1px);\n}\n\nhtml[data-theme='light'] .btn-toolbar-dropdown:hover {\n    background: rgba(0, 0, 0, 0.03);\n    border-color: rgba(0, 0, 0, 0.12);\n    color: #111827;\n}\n\n.btn-toolbar-dropdown.active-filter {\n    border-color: rgba(168, 85, 247, 0.4);\n    background: rgba(168, 85, 247, 0.05);\n    color: #a855f7;\n}\n\nhtml[data-theme='light'] .btn-toolbar-dropdown.active-filter {\n    border-color: rgba(168, 85, 247, 0.5);\n    background: rgba(168, 85, 247, 0.04);\n    color: #7e22ce;\n}\n\n.chevron-rotate {\n    transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.chevron-rotate.open {\n    transform: rotate(180deg);\n}\n\n/* Floating Glass Dropdown Panel */\n.dropdown-panel-glass {\n    position: absolute;\n    top: calc(100% + 6px);\n    right: 0;\n    width: 220px;\n    background: rgba(15, 23, 42, 0.85);\n    backdrop-filter: blur(24px) saturate(180%);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 14px;\n    padding: 0.4rem;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.05);\n    z-index: 1000;\n    \n    opacity: 0;\n    visibility: hidden;\n    pointer-events: none;\n    transform: translateY(-8px) scale(0.97);\n    transition: opacity 0.2s, visibility 0.2s, transform 0.2s;\n}\n\n.dropdown-panel-glass.open {\n    opacity: 1;\n    visibility: visible;\n    pointer-events: auto;\n    animation: slideDownFade 0.2s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\nhtml[data-theme='light'] .dropdown-panel-glass {\n    background: rgba(255, 255, 255, 0.95);\n    border: 1px solid rgba(0, 0, 0, 0.08);\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);\n}\n\n@keyframes slideDownFade {\n    from {\n        opacity: 0;\n        transform: translateY(-8px) scale(0.97);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0) scale(1);\n    }\n}\n\n.dropdown-panel-header {\n    font-size: 0.65rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: var(--text-muted);\n    padding: 0.4rem 0.75rem;\n    margin-bottom: 0.25rem;\n}\n\n.dropdown-panel-options {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.dropdown-option-btn {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding: 0.55rem 0.75rem;\n    border-radius: 8px;\n    border: none;\n    background: transparent;\n    color: var(--text-secondary);\n    font-size: 0.82rem;\n    font-weight: 550;\n    text-align: left;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\nhtml[data-theme='light'] .dropdown-option-btn {\n    color: #4b5563;\n}\n\n.dropdown-option-btn:hover {\n    background: rgba(255, 255, 255, 0.06);\n    color: var(--text-primary);\n}\n\nhtml[data-theme='light'] .dropdown-option-btn:hover {\n    background: rgba(0, 0, 0, 0.03);\n    color: #111827;\n}\n\n.dropdown-option-btn.selected {\n    background: rgba(99, 102, 241, 0.08);\n    color: #818cf8;\n}\n\nhtml[data-theme='light'] .dropdown-option-btn.selected {\n    background: rgba(99, 102, 241, 0.05);\n    color: #4f46e5;\n}\n\n.check-icon-purple {\n    color: #818cf8;\n}\n\nhtml[data-theme='light'] .check-icon-purple {\n    color: #4f46e5;\n}\n\n/* --- View Switcher Segmented Control --- */\n.view-switcher-premium {\n    display: flex;\n    align-items: center;\n    height: 42px;\n    background: rgba(255, 255, 255, 0.03);\n    backdrop-filter: blur(20px);\n    -webkit-backdrop-filter: blur(20px);\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    border-radius: 99px;\n    /* Rounded pill container */\n    padding: 3px;\n    gap: 2px;\n    box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.01), 0 4px 12px rgba(0, 0, 0, 0.05);\n    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\nhtml[data-theme='light'] .view-switcher-premium {\n    background: rgba(0, 0, 0, 0.015);\n    border-color: rgba(0, 0, 0, 0.06);\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.01), 0 2px 8px rgba(0, 0, 0, 0.02);\n}\n\n/* Subtle hover lift & shadow glow */\n.view-switcher-premium:hover {\n    transform: translateY(-1px);\n    border-color: rgba(168, 85, 247, 0.2);\n    box-shadow:\n        0 6px 20px rgba(0, 0, 0, 0.15),\n        0 0 10px rgba(168, 85, 247, 0.05),\n        inset 0 1px 1px rgba(255, 255, 255, 0.02);\n}\n\nhtml[data-theme='light'] .view-switcher-premium:hover {\n    border-color: rgba(124, 58, 237, 0.15);\n    box-shadow: 0 4px 12px rgba(124, 58, 237, 0.04);\n}\n\n.btn-switcher-tab {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    height: 100%;\n    padding: 0 1.5rem;\n    border-radius: 99px;\n    border: 1px solid transparent;\n    background: transparent;\n    color: var(--text-secondary);\n    font-size: 0.85rem;\n    font-weight: 600;\n    cursor: pointer;\n    opacity: 0.65;\n    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n    position: relative;\n    white-space: nowrap;\n}\n\n.btn-switcher-tab:hover {\n    opacity: 1;\n    color: var(--text-primary);\n    background: rgba(255, 255, 255, 0.03);\n}\n\nhtml[data-theme='light'] .btn-switcher-tab:hover {\n    background: rgba(0, 0, 0, 0.02);\n}\n\n/* Active Segment Highlight: glossy glassmorphism, LED border glow, elevated surface */\n.btn-switcher-tab.active {\n    opacity: 1;\n    color: #ffffff !important;\n    background: linear-gradient(135deg, rgba(168, 85, 247, 0.28) 0%, rgba(99, 102, 241, 0.24) 100%) !important;\n    border: 1px solid rgba(168, 85, 247, 0.6) !important;\n    box-shadow:\n        0 0 12px rgba(168, 85, 247, 0.35),\n        0 4px 10px rgba(0, 0, 0, 0.25),\n        inset 0 1px 0 rgba(255, 255, 255, 0.12) !important;\n}\n\nhtml[data-theme='light'] .btn-switcher-tab.active {\n    background: linear-gradient(135deg, rgba(124, 58, 237, 0.16) 0%, rgba(79, 70, 229, 0.16) 100%) !important;\n    color: #6d28d9 !important;\n    border: 1px solid rgba(124, 58, 237, 0.5) !important;\n    box-shadow:\n        0 0 10px rgba(124, 58, 237, 0.25),\n        0 4px 8px rgba(124, 58, 237, 0.1),\n        inset 0 1px 0 rgba(255, 255, 255, 0.2) !important;\n}\n\n/* Red/Green LED highlight when Drafts tab has drafts */\n.btn-switcher-tab.has-drafts::after {\n    content: '';\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: #10b981;\n    box-shadow: 0 0 8px #10b981;\n    display: inline-block;\n    margin-left: 2px;\n}\n\n/* Transition Blur effect for table container */\n.dms-table-container {\n    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.dms-table-container.transition-blur {\n    opacity: 0;\n    filter: blur(8px);\n    transform: scale(0.98);\n}\n\n/* --- Page Container & Global Depth --- */\n.dms-connections-container {\n    max-width: 1800px;\n    margin: 0;\n    padding: 0 0 4rem;\n    position: relative;\n    z-index: 1;\n}\n\n/* Subtle Data Grid Background Pattern */\n.dms-connections-container::before {\n    content: '';\n    position: absolute;\n    inset: -20px;\n    background-image:\n        linear-gradient(rgba(0, 0, 0, 0.02) 1px, transparent 1px),\n        linear-gradient(90deg, rgba(0, 0, 0, 0.02) 1px, transparent 1px);\n    background-size: 50px 50px;\n    mask-image: radial-gradient(circle at center, black 0%, transparent 80%);\n    pointer-events: none;\n    z-index: -1;\n}\n\nhtml[data-theme=\"dark\"] .dms-connections-container::before {\n    background-image:\n        linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),\n        linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);\n}\n\n/* Header classes removed in favor of global dms-page-header in EnterpriseDMS.css */\n\n.header-actions-premium {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 1.5rem;\n}\n\n/* Premium Add Button */\n.btn-add-nexus {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    background: var(--gradient-main);\n    color: white;\n    padding: 0.85rem 2.25rem;\n    border-radius: 16px;\n    font-weight: 600;\n    font-size: 1rem;\n    border: none;\n    cursor: pointer;\n    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n    box-shadow: 0 10px 30px rgba(99, 102, 241, 0.3);\n}\n\n.btn-add-nexus:hover {\n    transform: translateY(-4px) scale(1.02);\n    box-shadow: 0 20px 45px rgba(99, 102, 241, 0.4);\n}\n\n/* Premium Delete Selected Button */\n.btn-delete-selected-nexus {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    background: #ef4444;\n    color: white;\n    padding: 0.85rem 2.25rem;\n    border-radius: 16px;\n    font-weight: 600;\n    font-size: 1rem;\n    border: none;\n    cursor: pointer;\n    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n    box-shadow: 0 10px 30px rgba(239, 68, 68, 0.3);\n}\n\n.btn-delete-selected-nexus:hover {\n    transform: translateY(-4px) scale(1.02);\n    background: #dc2626;\n    box-shadow: 0 20px 45px rgba(239, 68, 68, 0.4);\n}\n\n/* â”€â”€ Context-Aware Help Popover â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */\n\n.field-info-btn {\n    border-radius: 50%;\n    padding: 2px !important;\n}\n\n.field-info-btn:hover,\n.field-info-btn.active {\n    color: var(--primary, #7c3aed) !important;\n    background: rgba(124, 58, 237, 0.1);\n}\n\n.help-popover-card {\n    position: absolute;\n    top: calc(100% + 12px);\n    left: -16px;\n    width: 320px;\n    z-index: 1000;\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);\n    display: flex;\n    flex-direction: column;\n    animation: popoverFadeIn 0.2s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n    cursor: default;\n}\n\n[data-theme='dark'] .help-popover-card {\n    background: #1e293b;\n    border: 1px solid #334155;\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.4);\n}\n\n.help-popover-arrow {\n    position: absolute;\n    top: -6px;\n    left: 24px;\n    width: 12px;\n    height: 12px;\n    background: #ffffff;\n    border-top: 1px solid #e2e8f0;\n    border-left: 1px solid #e2e8f0;\n    transform: rotate(45deg);\n    z-index: 1001;\n}\n\n[data-theme='dark'] .help-popover-arrow {\n    background: #1e293b;\n    border-top: 1px solid #334155;\n    border-left: 1px solid #334155;\n}\n\n.help-popover-content {\n    padding: 1.25rem;\n    position: relative;\n    z-index: 1002;\n    background: transparent;\n}\n\n.help-popover-content h3 {\n    margin: 0 0 1rem 0;\n    font-size: 0.9rem;\n    font-weight: 700;\n    color: var(--text-primary, #0f172a);\n}\n\n.help-popover-steps {\n    margin: 0;\n    padding-left: 1.25rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n}\n\n.help-popover-steps li {\n    font-size: 0.8rem;\n    line-height: 1.4;\n    color: #475569;\n}\n\n[data-theme='dark'] .help-popover-steps li {\n    color: #94a3b8;\n}\n\n@keyframes popoverFadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(4px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.form-control:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n/* Styling for migration table checkboxes */\n.dms-checkbox {\n    width: 14px;\n    height: 14px;\n    min-width: 14px;\n    min-height: 14px;\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n    cursor: pointer;\n    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.4);\n    border-radius: 2px;\n    accent-color: #3b82f6;\n}\n\nhtml[data-theme='light'] .dms-checkbox {\n    box-shadow: 0 0 0 1px #d1d5db;\n    background-color: #ffffff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
